
import OnbordingList from './onbordingList'
const routes = [
  {
    // type: 'collapse',
    key: 'home',
    route: '/',
    component: <OnbordingList />,
  },

]

export default routes
